import ApiService from '../../../../shared/services/ApiService';

export default {

    getSubscription() {
        return ApiService.get('billing/subscription');
    },

    getPaymentMethods() {
        return ApiService.get('billing/payment-methods');
    },

    getReceipts() {
        return ApiService.get('billing/receipts');
    },

    downloadReceipt(token) {
        return ApiService.downloadFile(`billing/download-receipt/${token}`);
    },

    purchaseSeats(data) {
        return ApiService.post('payment/billing/purchase-seats', data);
    },

    purchaseAdditionalSeats(data) {
        return ApiService.post('billing/purchase-additional-seats', data);
    },

    createSetupIntent() {
        return ApiService.get('billing/create-stripe-setup-intent');
    },

    addPaymentMethod(data) {
        return ApiService.post('billing/add-payment-method', data);
    },

    updatePaymentMethod(data) {
        return ApiService.post('billing/update-payment-method', data);
    },

    deletePaymentMethod(data) {
        return ApiService.post('billing/delete-payment-method', data);
    },

    cancelSubscription(data) {
        return ApiService.post('billing/cancel-subscription', data);
    },

    resumeSubscription() {
        return ApiService.post('billing/resume-subscription', {});
    },

    switchSubscriptionPlan() {
        return ApiService.post('billing/switch-subscription-plan', {});
    },

    cancelSwitchSubscriptionPlan() {
        return ApiService.post('billing/cancel-switch-subscription-plan', {});
    },

    getProratedCost() {
        return ApiService.get('billing/prorated-cost');
    },

    payInvoice(data) {
        return ApiService.post('billing/pay-invoice', data);
    },
}